// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  onChangeValidationErrors: ['validationErrors'],
  onChangeDiscountErrors: ['discountErrors'],
  onChangeValidationError: ['key', 'data'],
  onChangeValidationSig: ['validationSig'],
  onChangeDiscountValidationSig: ['discountValidationSig'],
  onChangeGeneralFailureError: ['error', 'key', 'data'],
  onResetValidationErrors: null,
  onChangeShowValidationErrorPanel: ['showValidationErrorPanel'],
})

export const ValidationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({ // eslint-disable-line
  validationSig: false,
  discountValidationSig: false,
  validationErrors: {},
  discountErrors: {},
  generalValidationErrors: {},
  showValidationErrorPanel: false,
})

/* ------------- Reducers ------------- */

const onChangeValidationErrorsR = (state, { validationErrors }) =>
  state.merge({ validationErrors })

const onChangeDiscountErrorsR = (state, { discountErrors }) =>
  state.set('discountErrors', discountErrors)

const onChangeValidationErrorR = (state, { key, data }) =>
  state.setIn(['validationErrors', ...(Array.isArray(key) ? key : [key])], !data ? {} : data)

const onChangeValidationSigR = (state, { validationSig }) =>
  state.merge({ validationSig })

const onChangeDiscountValidationSigR = (state, { discountValidationSig }) =>
  state.set('discountValidationSig', discountValidationSig)

const onChangeGeneralFailureErrorR = (state, { key, data }) =>
  state.setIn(['generalValidationErrors', key], !data ? {} : data)

const onResetValidationErrorsR = state =>
  state.merge({ generalValidationErrors: INITIAL_STATE.generalValidationErrors, validationErrors: INITIAL_STATE.validationErrors })

const onChangeShowValidationErrorPanelR = (state, { showValidationErrorPanel }) =>
  state.merge({ showValidationErrorPanel })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_CHANGE_VALIDATION_ERRORS]: onChangeValidationErrorsR,
  [Types.ON_CHANGE_DISCOUNT_ERRORS]: onChangeDiscountErrorsR,
  [Types.ON_CHANGE_VALIDATION_ERROR]: onChangeValidationErrorR,
  [Types.ON_CHANGE_VALIDATION_SIG]: onChangeValidationSigR,
  [Types.ON_CHANGE_DISCOUNT_VALIDATION_SIG]: onChangeDiscountValidationSigR,
  [Types.ON_CHANGE_GENERAL_FAILURE_ERROR]: onChangeGeneralFailureErrorR,
  [Types.ON_RESET_VALIDATION_ERRORS]: onResetValidationErrorsR,
  [Types.ON_CHANGE_SHOW_VALIDATION_ERROR_PANEL]: onChangeShowValidationErrorPanelR,
})
